import React from "react";
import { Modal, Form } from "antd";
import { observer } from "mobx-react";
import { Store } from "../../../store/Store";
import { PerGoalDonateTable } from "./PerGoalDonateTable";

export const PerGoalAchievedDlg = observer(() => {
  const [form] = Form.useForm();
  const { fundView } = Store.fundsStore;

  return (
    <Modal
      title="Set Goals Achieved"
      visible={fundView.showGoalsAchievedDlg}
      maskClosable={false}
      onOk={() => fundView.savePerGoalAchieved()}
      okButtonProps={{
        disabled: !fundView.canPerGoalSave,
      }}
      confirmLoading={fundView.saving}
      onCancel={() => (fundView.showGoalsAchievedDlg = false)}
      width={760}
      getContainer={false}
    >
      <PerGoalDonateTable></PerGoalDonateTable>
    </Modal>
  );
});
